/**
 * Profile completeness scoring — matches Core (`GolfAuthCoreRedesignMarch26`) so both apps
 * show the same strength score for the shared `profiles` row.
 */

export interface ProfileStrengthRow {
  name: string;
  email: string;
  phone: string | null;
  handicap: number | null;
  homeclub: string | null;
  /** ISO 3166-1 alpha-2. Replaced `city_id` on 2026-07-10 when the
   *  cities / suburbs tables were retired (see Core `profileStrength.ts`
   *  for the migration note). */
  country_code: string | null;
}

interface ProfileField {
  key: keyof ProfileStrengthRow;
  label: string;
  points: number;
  tip: string;
}

const PROFILE_FIELDS: ProfileField[] = [
  { key: 'name', label: 'Full name', points: 20, tip: '' },
  { key: 'email', label: 'Email address', points: 15, tip: '' },
  { key: 'phone', label: 'Phone number', points: 15, tip: '' },
  { key: 'handicap', label: 'Handicap index', points: 20, tip: '' },
  { key: 'homeclub', label: 'Home club', points: 15, tip: '' },
  { key: 'country_code', label: 'Country', points: 15, tip: '' },
];

function isFieldComplete(profile: ProfileStrengthRow, field: ProfileField): boolean {
  const value = profile[field.key];
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim().length > 0;
  if (typeof value === 'number') return true;
  return false;
}

export function calculateProfileStrength(profile: ProfileStrengthRow): { score: number } {
  let score = 0;
  for (const field of PROFILE_FIELDS) {
    if (isFieldComplete(profile, field)) score += field.points;
  }
  return { score };
}
